import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=0c5871aa"
import script from "./invoice-list.vue?vue&type=script&lang=js"
export * from "./invoice-list.vue?vue&type=script&lang=js"
import style0 from "./invoice-list.vue?vue&type=style&index=0&id=0c5871aa&prod&lang=scss"
import style1 from "./invoice-list.vue?vue&type=style&index=1&id=0c5871aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports